<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="1300"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer ref="bulkCompletionReportValidator">
      <v-card flat>
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>
            {{ type === 'Accepts' ? '運搬終了報告兼本登録（一括登録）' : '運搬終了報告（一括登録）' }}
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />

        <v-card-text
          v-if="manifest"
          class="px-2"
          flat
          style="max-height: 60vh;overflow-y: scroll"
        >
          <v-row dense>
            <!-- マニフェスト基本情報 -->
            <v-col
              cols="12"
              md="7"
            >
              <completion-basic
                :manifest.sync="manifest"
                :users="users"
                :drivers="drivers"
                :vehicles="vehicles"
                :quantity-units="quantityUnits"
                :valuables-quantity-units="valuablesQuantityUnits"
                :enable-full-section="enableFullSection"
                caller-type="bulk"
              />
            </v-col>
            <!-- /マニフェスト基本情報 -->

            <!-- マニフェスト数量情報 -->
            <v-col
              cols="12"
              md="5"
            >
              <completion-quantity
                :drivers="drivers"
                :enable-full-section="enableFullSection"
                :manifest.sync="manifest"
                :process-type="type"
                :quantity-units="quantityUnits"
                :users="users"
                :valuables-quantity-units="valuablesQuantityUnits"
                :vehicles="vehicles"
                caller-type="bulk"
              />
            </v-col>
            <!-- /マニフェスト数量情報 -->

          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          <v-btn
            class="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import CompletionBasic from "./contents/_CompletionBasic";
import CompletionQuantity from "./contents/_CompletionQuantity";

export default {
  name: "BulkCompletionReportDialog",
  components: {
    CompletionBasic,
    CompletionQuantity,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    manifestIds: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: () => null,
    },
    orderIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      manifest: null,
      users: [],
      drivers: [],
      vehicles: [],
      quantityUnits: [],
      valuablesQuantityUnits: [],
      enableFullSection: false,
    }
  },
  computed: {
  },
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.bulkCompletionReportValidator.reset());
      this.manifest = null;
      this.enableFullSection = false;
      if (newValue) {
        this.setVariable();
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverManifestCompletionReport', {
      fetchNew: 'new',
      bulkRegister: 'create',
    }),
    ...mapActions('DriverOrderCompletionReport', {
      fetchNewByOrder: 'new',
      bulkRegisterByOrder: 'create',
    }),
    ...mapActions('DriverMasterSearchUser', {
      fetchUsers: 'index',
    }),
    ...mapActions('DriverMasterSearchDriver', {
      fetchDrivers: 'only_text',
    }),
    ...mapActions('DriverMasterSearchVehicle', {
      fetchVehicles: 'search',
    }),
    ...mapActions('DriverMasterSearchQuantityUnit', {
      fetchQuantityUnits: 'index',
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback');
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      const $self = this;
      this.$refs.bulkCompletionReportValidator.validate().then((result) => {
        if (result) {
          setTimeout($self.registerInformation, 500);
        }
      })
    },
    registerInformation () {
      // 選択された複数マニフェストを同じ内容で更新
      let params = {
        manifest: this.manifest,
        ids: this.manifestIds,
        type: this.type,
      };
      if (this.type === "Managements") {
        params['target_section'] = this.manifest.bulk_section;
        this.bulkRegister({params: params}).then(() => {
          this.$emit('registerEvent');
        });
      } else {
        // 受注・発注は内部で区間を特定して処理を行うので区間情報は送信しない
        params['order_ids'] = this.orderIds;
        params['type'] = this.type;
        this.bulkRegisterByOrder({params: params}).then(() => {
          this.$emit('registerEvent');
        });
      }
    },
    /**
     * 初期情報の取得
     */
    setVariable () {

      if (this.type === "Managements") {
        this.enableFullSection = true;
        this.fetchNew().then((content) => {
          this.manifest = content;
          this.manifest.target_for_registration = true;
        });
      } else {
        this.fetchNewByOrder().then((content) => {
          this.manifest = content;
          this.manifest.target_for_registration = true;
        });
      }

      this.fetchUsers({without_invisible: true}).then((content) => { this.users = content.users });
      this.fetchDrivers({without_invisible: true}).then((content) => { this.drivers = content });
      this.fetchVehicles({ registered_number: true}).then((content) => {
        this.vehicles = content.vehicles;
      });
      /**
       * 数量単位を展開
       * 有価物の数量単位は「個・台」は不要なのでコードで落とす
       */
      this.fetchQuantityUnits().then((content) => {
        this.quantityUnits = content.quantity_units;
        this.valuablesQuantityUnits = content.quantity_units.filter(v => v.code !== '5');
      });
    },
  }
}
</script>

<style scoped lang="scss">

</style>
